import { environment } from 'src/environments/environment';
import { QBUser } from './user.model';

/**
 * File attachment metadata
 */
export class FileMeta {
  date?: string;
  rid?: number;
  link?: string;
  name?: string;
  relatedOsp?: number;
  description?: string;
  relatedProject?: number;
  category?: string;
  from?: string;
  user?: QBUser;
  cpName?: string;
  relatedDailyReport?: number;
  redlineLink?: string;

  constructor(data?: any) {
    if (!data) {
      return;
    }
    this.date = data[1]?.value;
    this.rid = data[3]?.value;
    this.link = data[6]?.value;
    this.name = data[7]?.value;
    this.relatedOsp = data[8]?.value;
    this.description = data[9]?.value;
    this.relatedProject = data[12]?.value;
    this.category = data[13]?.value;
    this.from = data[14]?.value;
    this.user = new QBUser(data[15]?.value);
    this.cpName = data[17]?.value;
    this.relatedDailyReport = data[18]?.value;
    // LH-49: QB "Redline Link" formula field (beacon markup editor URL); fid is env-specific
    this.redlineLink = data[environment.redlineLinkFieldId]?.value;
  }
}
